import * as React from "react";
import Avatar from "../avatar/avatar";

interface ProfileCardProps {
  name: string;
  memberSince: string;
  location: string;
}

const ProfileCard: React.FC<ProfileCardProps> = ({
  name = "Not Available",
  memberSince = "Not Available",
  location = "Not Available",
}) => {
  return (
    <div className="bg-primary text-white rounded-lg p-4">
      <div className="flex flex-col items-center mb-4">
        <Avatar size="xl" color="white" />
        <div className="text-center">
          <h2 className="font-ubuntu text-lg mb-4">{name || "Not Available"}</h2>
          <p className="font-ubuntu font-light text-sm">
            Member since {memberSince || "Not Available"}
          </p>
          <p className="font-ubuntu font-light text-sm">{location || "Not Available"}</p>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
